module.exports = __webpack_public_path__ + "img/7.c1e6976c.png";